'use strict';

var ArctickClient = require('../../apiClient');
var util = require('util');

function Motors() {
    ArctickClient.apply(this, arguments);
}

util.inherits(Motors, ArctickClient);

Motors.prototype.getMotors = function(options, callback) {
    this._makeRequest({
        method: 'GET',
        path: '/api/v2/plugins/'+ process.env.ACTUALIZAR_CATALOGO +'/custom-tables/Motores/?pageSize=50000'
    }, callback);
}

module.exports = Motors;
